import LogService from "services/LogService";
import CREDIT_EVENTS from "utils/CreditEvents";
import CookieService from "services/CookieService";
import { Routes } from "routes/RouteConstants";

export const handleAddCredits = (router:any) => () => {
    LogService.log(CREDIT_EVENTS.BUY_CREDITS_CLICKED, {
      source: "TRANSACTION-HISTORY-V2"
    });

    const isNativeApp = CookieService.getCookie("is_native_app");

    if (isNativeApp) {
      window.open(`/hire${Routes.PLAN_SELECTION}`, "_blank");
      return;
    }
    router.push(Routes.PLAN_SELECTION);
  };
